import React from 'react';
import { View, Platform } from 'react-native';
import { TouchableRipple, Checkbox as MyCheckBox, Text } from 'react-native-paper';

export default function Checkbox({ onChange, onBlur, value, label }){
  const [status, setStatus] = React.useState(false);

  React.useEffect(() => {
    if (value !== undefined) {
      setStatus(value)
    }
  }, [])

  const onPress = (state) => {
    setStatus(state);
    onChange(state);
  }

  return (
    <TouchableRipple onPress={() => onPress(!status)} rippleColor="rgba(0, 0, 0, .04)" style={{ flex: 1, height: 48, paddingHorizontal: 4, borderBottomColor: '#BFC0C5', borderBottomWidth: 1, flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <>
        <Text style={{ fontSize: 14, color: '#5B5E63' }}>{label}</Text>
        <MyCheckBox
          status={status ? 'checked' : 'unchecked'}
        />
      </>
    </TouchableRipple>
  );
};